export const preciseAssociation = [
  {
    path: `/PreciseAssociation`,
    name: `PreciseAssociation`,
    redirect: `/PreciseAssociation/add`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/PreciseAssociation/add/:projectId/:groupId/:groupName/:isService/:routerPath',
        name: 'PreciseAssociation/add',
        component: () => import('@/views/preciseAssociation/PreciseAssociation')
      }
    ]
  }
];
